// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorContainer_errorContainer__XL03Z","errorWrapper":"ErrorContainer_errorWrapper__f5iWn","errorMessage":"ErrorContainer_errorMessage__cTDS2"};